export default __webpack_public_path__ + "static/media/exit-purple.086dd235.svg";